export default __webpack_public_path__ + "static/media/manual-search-hover.75d6bf16.png";